import * as React from 'react';
const SvgMobileDesign = (props) => (
  <svg viewBox="0 0 106 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.733 26.724V7.645C22.733 4.53 25.287 2 28.432 2c0 0 56.294.045 56.694.13 2.553.556 4.47 2.815 4.47 5.515v7.238M88.22 120.031A5.699 5.699 0 0 1 83.897 122H28.432c-3.145 0-5.699-2.53-5.699-5.645V80.951M89.596 62.754v6.126"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m74.811 2.576-2.513 7.223a4.276 4.276 0 0 1-4.04 2.855H44.07a4.267 4.267 0 0 1-4.04-2.855l-2.512-7.223M99.464 20.834H68.516c-2.505 0-4.536 2.011-4.536 4.493v24.048c0 2.481 2.031 4.493 4.536 4.493h30.948c2.505 0 4.536-2.012 4.536-4.493V25.327c0-2.482-2.031-4.493-4.536-4.493ZM83.988 30.246v16.083"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M76.046 31.212v-1.467h15.891v1.467M25.245 56.828c4.019 0 7.276-3.227 7.276-7.208 0-3.98-3.257-7.208-7.276-7.208-4.018 0-7.275 3.227-7.275 7.208 0 3.981 3.257 7.208 7.276 7.208ZM11.94 69.15c0-3.766 1.597-7.162 4.15-9.567M34.656 59.834a13.082 13.082 0 0 1 3.898 9.321"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.674 58.154c2.663-11.176-4.324-22.375-15.605-25.012-11.281-2.638-22.585 4.283-25.248 15.46-2.663 11.176 4.324 22.374 15.606 25.012 11.281 2.638 22.585-4.284 25.247-15.46ZM97.109 74.946H56.994c-1.201 0-2.175.964-2.175 2.153v30.71c0 1.19.974 2.154 2.174 2.154H97.11c1.2 0 2.174-.964 2.174-2.154v-30.71c0-1.19-.974-2.153-2.174-2.153Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m85.879 97.576 3.448-3.581c1.28-1.333 3.57-1.333 4.854 0l5.097 5.294M88.458 109.963l-6.988-7.944-4.444-5.049a3.24 3.24 0 0 0-4.854 0l-4.58 5.204-6.852 7.794M54.815 87.733c.151.12.298.25.43.406l4.444 5.054 3.357 3.812M85.84 86.013c.595-2.502-.969-5.008-3.493-5.598-2.525-.59-5.055.959-5.65 3.46-.597 2.501.967 5.007 3.492 5.598 2.525.59 5.054-.959 5.65-3.46Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgMobileDesign;
